<h1>{{ header | translate }}</h1>

<section>
  <div class="icon"></div>
  <p> {{ message | translate }}</p>
</section>
